import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"

const TablaDeudapp = props => {


    const [deuda, setDeuda] = useState(0.00);

    let op = require('../../../../src/modulos/datos');



    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { id: '', label: 'AÑO', width: '10px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'MES', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'DESCRIPCIÓN', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'MONTO', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'UBICACIÓN', width: '150px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
    ]

    const {
        TblContainer,
        TblHead,
    } = useTableFijo(records, headCells, filterFn, 220);


    useEffect(() => {


        if (props.tabdeuda) {

            let deu = parseFloat(0.00);
            let inte = parseFloat(0.00);
            let reca = parseFloat(0.00);
            for (let i = 0; i < props.tabdeuda.length; i++) {
                deu = deu + parseFloat(props.tabdeuda[i].monto);
            }
            setDeuda(formatMoneda(deu.toString().replace('.', ','), ',', '.', 2));
            setRecords(props.tabdeuda);
        }


    }, [props.tabdeuda]);

    const imprimirDeuda = (reporte) => (event) => {
        event.preventDefault();
        var sql = "B.IdCOMERCIO=" + parseInt(props.idcomercio);
        var radioBolivares = 1;
        var valpetro = props.valorpetro;
        reporte = 'EdoCtaCorto2Public';
        window.open(op.reportes + "/propagandapublicidad?" + "reporte=" + reporte + "&sql=" + sql + "&valpetro=" + valpetro + "&radioBolivares=" + radioBolivares, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    }


    return (
        <div className="card">
            <div class="card-header">
                <div className="row col-md-12" style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }}>
                    <div className="container row col-md-11 mx-auto">
                        <div className="col-md-7 row ml-auto">
                            <div className="col-md-7">
                                <div className="input-group input-group-sm mb-3">
                                    <div className="input-group-prepend" style={{ width: 80 }}>
                                        <span className="input-group-text w-100">Total Deuda: </span>
                                    </div>
                                    <input type="text" disabled={true} className="form-control text-right" name='deuda' value={deuda} />
                                </div>
                            </div>
                            <div className="col-md-5">
                                <button type="button" onClick={imprimirDeuda('EdoCtaCorto2Public')} class="btn btn-primary btn-sm rounded-circle"><i className="fas fa-print"></i> </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="content" >
                    <div className="container">
                        <div className="row col-md-12">
                            <div className="container" >
                                <div className="col-md-12">
                                    <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                        <TblHead />

                                        <tbody>
                                            {

                                                records && records.map((item, index) => (
                                                    <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.anio}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.mes}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descripcion}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.ubicacion}</td>
                                                    </tr>

                                                ))
                                            }
                                        </tbody>

                                    </TblContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaDeudapp;
